import { Navigate } from 'react-router';
import { useSecureToken } from '@/shared/hooks/useSecureToken';

export function SecureLinkRoute({ children }) {
  const { isValidToken, isLoading } = useSecureToken();

  if (isLoading) {
    return <div>Validating access...</div>;
  }

  return isValidToken ? children : <Navigate to="/login" replace />;
}
